export class Eigenbauleistungen {
  erbracht = false;
  betrag: number | null;
  statik: boolean | null;

  constructor() {
    this.betrag = null;
    this.statik = null;
  }
}
